import { Colors } from '@oy/uicore';
import { SystemIcon } from '@oy/uiicon';
import classNames from 'classnames';
import React, {
  ButtonHTMLAttributes,
  DetailedHTMLProps,
  forwardRef,
  Ref,
  useState,
} from 'react';
import styles from './IconButton.module.css';

type IconButtonProps = DetailedHTMLProps<
  ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
> & {
  iconColor?: string;
  disabledSecondary?: boolean;
};

const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  (
    {
      className,
      iconColor = Colors.WHITE,
      disabledSecondary = false,
      ...props
    }: IconButtonProps,
    ref: Ref<HTMLButtonElement>,
  ) => {
    const classes = classNames(
      styles.round,
      styles.extraMini,
      !disabledSecondary && styles.secondary,
    );
    const [isPressed, setIsPressed] = useState(false);

    const eventClasses = classNames({
      [styles.pressed]: isPressed,
    });

    const iconSize = 10;

    const handleMouseDown = () => {
      setIsPressed(true);
    };
    const handleMouseUp = () => {
      setIsPressed(false);
    };

    return (
      <button
        {...props}
        type="button"
        ref={ref}
        onMouseDown={handleMouseDown}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleMouseUp}
        className={classNames(
          styles.buttonBase,
          classes,
          eventClasses,
          className,
        )}
      >
        <SystemIcon color={iconColor} name="close" size={iconSize} />
      </button>
    );
  },
);

export default IconButton;
